import { useMemo } from "react"
import { matchPath, useLocation } from "react-router"
import { abstractRoutePaths, routePaths } from "../Routes"
import { AppDetailRouteParams } from "../Routes/Paths/Dashboard/AppDetailRoute"
import { JobsDetailRouteParams } from "../Routes/Paths/Dashboard/JobDetailRoute"

export const useAppDetailsPaths = (): [
    boolean,
    (
        orgUsername: string,
        appID: string,
        params?: AppDetailRouteParams,
        selected?: number[],
        jobID?: string
    ) => string,
    (
        orgUsername: string,
        appID: string,
        jobID: string,
        params?: JobsDetailRouteParams,
        selected?: number[]
    ) => string,
    (
        orgUsername: string,
        appID: string,
        jobID: string,
        params?: JobsDetailRouteParams
    ) => string
] => {
    const location = useLocation()

    return useMemo(() => {
        const isMessagesRoute =
            matchPath(location.pathname, {
                path: abstractRoutePaths.jobsMessageDetail
            }) !== null ||
            matchPath(location.pathname, {
                path: abstractRoutePaths.appDetailMessages
            }) !== null

        if (isMessagesRoute) {
            return [
                true,
                routePaths.appDetailMessages,
                routePaths.jobsMessageDetail,
                routePaths.jobsMessageReview
            ]
        } else {
            return [
                false,
                routePaths.appDetail,
                routePaths.jobsDetail,
                routePaths.jobsReview
            ]
        }
    }, [location])
}
